import { useParams } from 'react-router-dom';
import { useLevelLoadError } from '../../../../../hooks/admin/useLevelLoadError.hook';
import { useLevelUnmount } from '../../../../../hooks/admin/useLevelUnmount.hook';
import { useSetBreadcrumbs } from '../../../../../hooks/admin/useSetBreadcrumbs.hook';
import { ADMIN_SCHOOL_MANAGEMENT_RESOURCE } from '../../../../../resources/admin/admin.school.management.resource';
import { schools } from '../../../../../services/bff.api';
import ResourceTable from '../../../../core/ResourceTable';

const AdminSchoolManagements = () => {
  const params = useParams();
  const resource = {
    ...ADMIN_SCHOOL_MANAGEMENT_RESOURCE,
    table: {
      ...ADMIN_SCHOOL_MANAGEMENT_RESOURCE.table,
      dataTransform: (data) =>
        data?.map((i) => ({ ...i, name: i?.spoEntityData?.agodi?.name, netId: params.netId, netName: 'test' }))
    },
    api: { get: (urlConfig) => schools.getManagements(params.netId, urlConfig) }
  };

  useSetBreadcrumbs(ADMIN_SCHOOL_MANAGEMENT_RESOURCE.key);
  useLevelLoadError(ADMIN_SCHOOL_MANAGEMENT_RESOURCE.key);
  useLevelUnmount(ADMIN_SCHOOL_MANAGEMENT_RESOURCE.key);

  return (
    <div className="spo-o-admin-school-management">
      <ResourceTable resource={resource} />
    </div>
  );
};

export default AdminSchoolManagements;
